<template>
    <b-form @submit.prevent="onSubmit">
        <div class="form-group row">
            <div class="col-lg-8 offset-sm-4">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" v-model="isDifferentDeliveryAddress"
                           id="form-field-deviant">
                    <label class="custom-control-label" for="form-field-deviant">{{ $t('personal_data.deviant')
                        }}</label>
                </div>
            </div>
        </div>
        <template v-if="isDifferentDeliveryAddress">
            <div class="form-group row">
                <label for="form-field-shipping-first_name" class="col-lg-4 col-form-label" :class="{'text-right': !isMobile}">
                    {{ $t('personal_data.first_name') }}*
                </label>
                <div class="col-lg-8">
                    <b-form-input id="form-field-shipping-first_name" v-model="form.shipping_first_name" type="text"
                                  :state="validation.shipping_first_name.valid"
                                  required></b-form-input>
                    <b-form-invalid-feedback :state="validation.shipping_first_name.valid">
                        {{ validation.shipping_first_name.message }}
                    </b-form-invalid-feedback>
                </div>
            </div>
            <div class="form-group row">
                <label for="form-field-shipping-last_name" class="col-lg-4 col-form-label" :class="{'text-right': !isMobile}">
                    {{ $t('personal_data.second_name') }}*
                </label>
                <div class="col-lg-8">
                    <b-form-input id="form-field-shipping-last_name" v-model="form.shipping_last_name" type="text"
                                  :state="validation.shipping_last_name.valid"
                                  required></b-form-input>
                    <b-form-invalid-feedback :state="validation.shipping_last_name.valid">
                        {{ validation.shipping_last_name.message }}
                    </b-form-invalid-feedback>
                </div>
            </div>
            <!--<div class="form-group row">
                <label for="form-field-shipping-house_number" class="col-lg-4 col-form-label" :class="{'text-right': !isMobile}">
                    {{ $t('personal_data.house_number') }}*
                </label>
                <div class="col-lg-8">
                    <b-form-input id="form-field-shipping-house_number" v-model="form.shipping_address_house_number"
                                  type="text"
                                  :state="validation.shipping_address_house_number.valid"
                                  required></b-form-input>
                    <b-form-invalid-feedback :state="validation.shipping_address_house_number.valid">
                        {{ validation.shipping_address_house_number.message }}
                    </b-form-invalid-feedback>
                </div>
            </div>-->
            <div class="form-group row">
                <label for="form-field-shipping-street" class="col-lg-4 col-form-label" :class="{'text-right': !isMobile}">
                    {{ $t('personal_data.street') }}*
                </label>
                <div class="col-lg-8">
                    <b-form-input id="form-field-shipping-street" v-model="form.shipping_address_street" type="text"
                                  :state="validation.shipping_address_street.valid"
                                  required></b-form-input>
                    <b-form-invalid-feedback :state="validation.shipping_address_street.valid">
                        {{ validation.shipping_address_street.message }}
                    </b-form-invalid-feedback>
                </div>
            </div>
            <div class="form-group row">
                <label for="form-field-shipping-shipping-zip" class="col-lg-4 col-form-label" :class="{'text-right': !isMobile}">
                    {{ $t('personal_data.post_code') }}*
                </label>
                <div class="col-lg-8">
                    <b-form-input id="form-field-shipping-shipping-zip" v-model="form.shipping_address_zip" type="text"
                                  :state="validation.shipping_address_zip.valid"
                                  required></b-form-input>
                    <b-form-invalid-feedback :state="validation.shipping_address_zip.valid">
                        {{ validation.shipping_address_zip.message }}
                    </b-form-invalid-feedback>
                </div>
            </div>
            <div class="form-group row">
                <label for="form-field-shipping-city" class="col-lg-4 col-form-label" :class="{'text-right': !isMobile}">
                    {{ $t('personal_data.city') }}*
                </label>
                <div class="col-lg-8">
                    <b-form-input id="form-field-shipping-city" v-model="form.shipping_address_city" type="text"
                                  :state="validation.shipping_address_city.valid"
                                  required></b-form-input>
                    <b-form-invalid-feedback :state="validation.shipping_address_city.valid">
                        {{ validation.shipping_address_city.message }}
                    </b-form-invalid-feedback>
                </div>
            </div>
            <div class="form-group row">
                <label for="form-field-shipping-country" class="col-lg-4 col-form-label" :class="{'text-right': !isMobile}">
                    {{ $t('personal_data.country') }}*
                </label>
                <div class="col-lg-8">
                    <b-form-select id="form-field-shipping-country" v-model="form.shipping_address_country"
                                   value-field="id"
                                   text-field="name"
                                   :state="validation.shipping_address_country.valid"
                                   :options="countryOptions"
                                   required></b-form-select>
                    <b-form-invalid-feedback :state="validation.shipping_address_country.valid">
                        {{ validation.shipping_address_country.message }}
                    </b-form-invalid-feedback>
                </div>
            </div>
        </template>
        <div class="row">
            <div class="col-lg-8 offset-sm-4">
                <button type="submit" class="btn btn-success">{{ $t('personal_data.save') }}
                </button>
            </div>
        </div>
    </b-form>
</template>

<script>
  import shippingAddress from 'src/mixins/shippingAddressComponent';

  export default {
    mixins: [shippingAddress],
  };
</script>
